import React from "react";

import cn from "classnames";

import Activity from "@mapmycustomers/shared/types/entity/Activity";

import styles from "./BulkActions.module.scss";
import BulkDeleteButton from "./BulkDeleteButton";
import BulkEditButton from "./BulkEditButton";
import BulkPostponeButton from "./BulkPostponeButton";
import BulkToggleCompleteButton from "./BulkToggleCompleteButton";

interface Props {
  className: string;
  selected: Activity[];
}

const BulkActions: React.FC<Props> = ({ className, selected }) => {
  return (
    <div className={cn(className, styles.container)}>
      <BulkToggleCompleteButton className={styles.button} selected={selected} />
      <BulkPostponeButton className={styles.button} selected={selected} />
      <BulkEditButton className={styles.button} selected={selected} />
      <BulkDeleteButton className={styles.button} selected={selected} />
    </div>
  );
};

export default BulkActions;
